<template>
  <div class="beneficiary">
    <div class="r-text-regular">
      צו איסור הלבנת הון מחייב אותנו לבקש ממך
      להצהיר לגבי ״נהנים״ בחשבון.
    </div>

    <div class="r-text-regular">אני מצהיר.ה בזה כי:</div>

    <r-list>
      <beneficiary-option>
        <r-item-section>
          <r-item-label>
            <div class="row items-center q-gutter-sm">
              <default-radio
                :value="beneficiaryChoice"
                :val="BeneficiaryOptions.MYSELF"
                label="אני פועל.ת בשביל עצמי"
                @input="emitBeneficiaryChoice" />
            </div>
          </r-item-label>
          <r-item-label>
            וכי אין נהנה
            בזכויות הגלומות בפוליסה/חשבון זולת
            בעל הפוליסה והמבוטח/העמית למעט
            זכויותיהם של המוטבים למקרי חיים
            והמוטבים למקרי מוות בפוליסה/בחשבון.
          </r-item-label>
        </r-item-section>
      </beneficiary-option>

      <r-separator/>

      <beneficiary-option>
        <r-item-section>
          <r-item-label>
            <div class="row items-center q-gutter-sm">
              <default-radio
                :value="beneficiaryChoice"
                :val="BeneficiaryOptions.OTHERS"
                label="הנהנים בפוליסה/בחשבון הם..."
                @input="emitBeneficiaryChoice"  />
            </div>
            <collapse-transition>
              <div v-if="beneficiaryChoice === BeneficiaryOptions.OTHERS" class="column">
                  <beneficiary-form
                    v-bind="beneficiaries[0]"
                    @beneficiary="setFirstBeneficiary"
                    class="beneficiary-form"
                    @observe="observe"
                    @unobserve="unobserve"/>
              </div>
            </collapse-transition>
          </r-item-label>
        </r-item-section>
      </beneficiary-option>

      <r-separator/>

      <beneficiary-option>
        <r-item-section>
          <r-item-label>
            <div class="row no-wrap items-center q-gutter-sm">
              <default-radio
                :value="beneficiaryChoice"
                :val="BeneficiaryOptions.UNKNOWN"
                @input="emitBeneficiaryChoice"
                label="יש נהנה בזכויות כאמור, ואולם פרטי הזיהוי שלו טרם ידועים."/>
            </div>
            <collapse-transition>
              <div v-if="beneficiaryChoice === BeneficiaryOptions.UNKNOWN" class="column unknown-reason-input">
                <default-text-input
                  label="הסיבה היא..."
                  :value="beneficiaryUnknownReason"
                  validations="required"
                  @input="setBeneficiaryUnknownReason"
                  @observe="observe"
                  @unobserve="unobserve" />
              </div>
            </collapse-transition>
          </r-item-label>
        </r-item-section>
      </beneficiary-option>
    </r-list>

    <r-separator/>

    <div class="commit-to-communicate-changes">
      <span class="r-text-bold"> אני מתחייב.ת להודיע על כל שינוי בפרטים שמסרתי לעיל.</span>
      <span>
        ידוע לי כי מסירת מידע כוזב, לרבות אי
      מסירת עדכון של פרט החייב בדיווח, במטרה
      שלא יהיה דיווח או כדי לגרום לדיווח בלתי נכון לפי
      סעיף 7 לחוק איסור הלבנת הון, התש״ס 2000 -
      מהווה עבירה פלילית.

      </span>

    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { BeneficiaryOptions } from '@/constants/meitav-dash/open-fund';
import RList from '@/components/base/RList';
import RItemSection from '@/components/base/RItemSection';
import RItemLabel from '@/components/base/RItemLabel';
import BeneficiaryForm from '@/components/meitav-dash/open-fund/statements/BeneficiaryForm';
import RSeparator from '@/components/base/RSeparator';
import DefaultRadio from '@/components/styled/DefaultRadio';
import BeneficiaryOption from '@/components/meitav-dash/open-fund/statements/BeneficiaryOption';
import ValidationObserver from '@/mixins/ValidationObserver';
import DefaultTextInput from '@/components/styled/DefaultTextInput';

export default {
  name: 'Beneficiary',
  components: {
    DefaultTextInput,
    CollapseTransition: BaseUI.CollapseTransition,
    BeneficiaryOption,
    DefaultRadio,
    RSeparator,
    BeneficiaryForm,
    RItemLabel,
    RItemSection,
    RList,
  },
  mixins: [ValidationObserver],
  props: {
    beneficiaryChoice: String,
    beneficiaries: Array,
    beneficiaryUnknownReason: String,
  },
  computed: {
    BeneficiaryOptions() {
      return BeneficiaryOptions;
    },
  },
  methods: {
    emitBeneficiaryChoice(value) {
      this.$emit('beneficiary-choice', value);
    },
    setFirstBeneficiary(value) {
      this.$emit('beneficiary-changed', { beneficiary: value, index: 0 });
    },
    setBeneficiaryUnknownReason(value) {
      this.$emit('beneficiary-unknown-reason', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.beneficiary-form {
  margin-top: 16px;
}

.unknown-reason-input {
  margin-top: 16px;
}

.commit-to-communicate-changes {
  margin-top: 16px;
}
</style>
